<template>
  <div class="project-list-page">
    <!-- 导航栏 -->
    <van-nav-bar
      title="项目报名"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    >
      <template #right>
        <van-icon name="wap-home" size="20" @click="goHome" />
      </template>
    </van-nav-bar>

    <!-- 下拉刷新 -->
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
      :disabled="!isAtTop"
    >
      <div class="content-wrapper">
        <!-- 比赛信息头部 -->
        <div class="competition-header">
          <div class="header-bg"></div>
          <div class="header-content">
            <div class="competition-title">
              <h2>{{ SSMC }}</h2>
              <p v-if="STARTDATE && STARTDATE.length > 0">
                {{ STARTDATE + " 至 " + ENDDATE }}
              </p>
            </div>
            <div class="stats-summary">
              <div class="stat-box">
                <span class="stat-num">{{
                  maxRCount - 0 > 9998 ? "无限制" : maxRCount
                }}</span>
                <span class="stat-text">最大人数</span>
              </div>
              <div class="stat-divider" v-if="ISBMRCOUNT === '1'"></div>
              <div class="stat-box" v-if="ISBMRCOUNT === '1'">
                <span class="stat-num">{{ ybmRCount }}</span>
                <span class="stat-text">已报人数</span>
              </div>
              <div class="stat-divider"></div>
              <div class="stat-box">
                <span class="stat-num">{{
                  MAXXMCOUNT - 0 > 9998 ? "无限制" : MAXXMCOUNT
                }}</span>
                <span class="stat-text">最大兼项数</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 筛选栏 -->
        <div class="filter-section">
          <div class="filter-tabs">
            <div
              v-for="(tab, index) in filterTabs"
              :key="index"
              class="filter-tab"
              :class="{ active: currentTab === tab.value }"
              @click="switchTab(tab.value)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>

        <!-- 队伍信息 -->
        <div
          class="team-info-section"
          v-if="(DWQC || DWJC || LDXM || LDTEL) && dwid.length > 0"
        >
          <div class="team-info-card">
            <div class="team-info-title">
              <van-icon name="friends-o" />
              <span>队伍信息</span>
            </div>
            <div class="team-info-content">
              <div class="info-row" v-if="DWQC">
                <span class="info-label">队伍全称：</span>
                <span class="info-value">{{ DWQC }}</span>
              </div>
              <div class="info-row" v-if="DWJC">
                <span class="info-label">队伍简称：</span>
                <span class="info-value">{{ DWJC }}</span>
              </div>
              <div class="info-row" v-if="LDXM">
                <span class="info-label">领队姓名：</span>
                <span class="info-value">{{ LDXM }}</span>
              </div>
              <div class="info-row" v-if="LDTEL">
                <span class="info-label">领队电话：</span>
                <span class="info-value">{{ LDTEL }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 项目选择提示 -->
        <div class="project-tip-section">
          <div class="tip-content">
            <van-icon name="info-o" />
            <span v-if="showXmlx === 'DX'"
              >以下是可报名项目，请选择您要报名的项目</span
            >
            <span v-else-if="showXmlx === 'TEAM' && reportLx === 'LDBM'"
              >以下是可报名（团体）项目，请选择您要报名的项目</span
            >
            <span v-else-if="showXmlx === 'TEAM' && reportLx === 'DYBM'"
              >请选择团体项目，进行添加队员</span
            >
            <span v-else>以下是可报名项目，请选择您要报名的项目</span>
          </div>
        </div>

        <!-- 项目列表 -->
        <div class="project-list">
          <!-- 按组别分组显示 -->
          <div
            v-for="(xmGroup, groupIndex) in filteredResultXmList"
            :key="groupIndex"
            class="group-section"
          >
            <!-- 组别标题 -->
            <div class="group-header">
              <div class="group-title">
                <span class="group-icon">🏆</span>
                <span class="group-name">{{ xmGroup.XMJC }}</span>
              </div>
              <div class="group-count">
                {{ xmGroup.DATALIST.length }} 个项目
              </div>
            </div>

            <!-- 该组别的项目列表 -->
            <div
              v-for="(item, index) in xmGroup.DATALIST"
              :key="index"
              class="project-item-wrapper"
            >
              <div
                class="project-item"
                :class="{ 'is-registered': item.ITEMISBM === '1' }"
                @click="handleProjectClick(item)"
              >
                <div class="project-main">
                  <div class="project-left">
                    <div
                      class="project-badge"
                      :class="getProjectType(item.SSLX)"
                    >
                      {{
                        ssid ===
                        "527877794a516f347a49495071786e61465a6d476665526b4635325370597655"
                          ? item.SSLXMC.replace("单", "")
                          : item.SSLXMC
                      }}
                    </div>
                    <div class="project-info">
                      <div class="title-row">
                        <h3 class="project-title">
                          {{
                            item.XMJC +
                              " " +
                              (ssid ===
                              "527877794a516f347a49495071786e61465a6d476665526b4635325370597655"
                                ? item.SSLXMC.replace("单", "")
                                : item.SSLXMC)
                          }}
                        </h3>
                        <span
                          v-if="
                            item.BMSET &&
                              item.BMSET[0] &&
                              item.BMSET[0].ISKZBM === 'Y'
                          "
                          class="cross-group-tag"
                        >
                          <van-icon name="exchange" />
                          跨组
                        </span>
                      </div>
                      <div class="project-meta" v-if="ISBMRCOUNT === '1'">
                        <span class="meta-item" style="font-size:0.85rem">
                          <van-icon name="friends-o" />
                          <span class="registered-count">{{
                            item.YBMRS + getCountUnit(item.SSLX)
                          }}</span>
                          <span class="divider">/</span>
                          <span>{{
                            item.BMRSXZ > 998
                              ? "不限"
                              : item.BMRSXZ + getCountUnit(item.SSLX)
                          }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="project-right">
                    <div v-if="item.ITEMISBM === '1'" class="registered-badge">
                      <van-icon name="success" />
                      <span>已报名</span>
                    </div>
                    <div class="fee-tags">
                      <span v-if="item.ISSF === '1'" class="meta-item fee-item">
                        <van-icon name="gold-coin-o" />
                        {{ item.SFJE - 0 > 0 ? item.SFJE + "元" : "多标准" }}
                      </span>
                      <van-tag
                        type="warning"
                        v-if="
                          item.ISHYMF === '1' && item.SSLX.substr(1, 2) !== 'T'
                        "
                        class="member-tag"
                      >
                        会员优惠
                      </van-tag>
                    </div>
                  </div>
                </div>
                <div class="project-footer" v-if="item.BMSET && item.BMSET[0]">
                  <span class="birth-date">
                    <van-icon name="calendar-o" />
                    <template v-if="item.BMSET[0].ISXZCSRQ === '1'">
                      {{ item.BMSET[0].STARTCSDATE || "" }} ~
                      {{ getEndDate(item.BMSET[0]) }}
                    </template>
                    <template v-else>
                      不限制出生日期
                    </template>
                  </span>
                  <van-button
                    type="primary"
                    size="small"
                    round
                    @click.stop="navRmbmUrl(item, item.ITEMISBM)"
                  >
                    报名
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-if="resultXmList.length === 0 && !isLoading" class="empty-state">
          <van-empty description="暂无项目" />
        </div>
      </div>
    </van-pull-refresh>

    <!-- 返回顶部 -->
    <back-to-top-com />
    <loading-com></loading-com>
  </div>
</template>

<script>
import BackToTopCom from "../commonCom/BackToTopCom.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import { Dialog } from "vant";
export default {
  name: "ProjectListIndex",
  components: {
    BackToTopCom,
    LoadingCom
  },
  data() {
    return {
      maxRCount: 0,
      ybmRCount: 0,
      SSMC: "",
      ISBMRCOUNT: "",
      MAXXMCOUNT: "",
      STARTDATE: "",
      ENDDATE: "",
      // 队伍信息
      DWQC: "",
      DWJC: "",
      LDXM: "",
      LDTEL: "",
      isLoading: false,
      isAtTop: true,
      currentTab: "all",
      // API相关
      utilPost: "",
      ssid: "",
      op: "",
      // 比赛信息
      registeredCount: 0,

      // 筛选标签
      filterTabs: [{ label: "全部", value: "all" }],

      // 项目列表
      resultXmList: [], // 原始API数据
      showXmlx: "DX",
      reportLx: "",
      isLd: "",
      bmLx: "",
      dwid: "",
      czlx: "",
      checkBmrsLx: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.showXmlx = this.$route.query.showXmlx;
    this.reportLx = this.$route.query.reportLx;
    this.isLd = this.$route.query.isLd;
    this.bmLx = this.$route.query.bmLx;
    this.dwid = this.$route.query.dwid;
    this.czlx = this.$route.query.czlx;
    this.checkBmrsLx = this.$route.query.checkBmrsLx;
    this.op = this.$route.query.op || "wapGL";
  },
  computed: {
    // 过滤后的resultXmList
    filteredResultXmList() {
      if (this.currentTab === "all") {
        return this.resultXmList;
      } else if (this.currentTab === "registered") {
        // 只显示已报名的组别
        return this.resultXmList.filter(xmGroup => xmGroup.ISBM === "1");
      } else {
        // 按组别筛选
        return this.resultXmList.filter(
          xmGroup => xmGroup.XMJC === this.currentTab
        );
      }
    }
  },
  mounted() {
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    window.addEventListener("scroll", this.handleScroll);
    this.getXmData();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getXmData() {
      // 获取比赛项目
      var busData = {
        czlx: this.czlx,
        dwid: this.dwid,
        bmLx: this.showXmlx === "DX" ? "" : "TEAM",
        sslxTypeRequest: this.showXmlx === "DX" ? "" : "T",
        isLd: this.isLd,
        czlx: this.czlxc,
        checkBmrsLx: this.checkBmrsLx,
        reportLx: this.reportLx,
        isLoadDtInfo: "0",
        isLoadRyCount: "1"
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "getXmData"
        },
        busData: busData
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        // console.log(JSON.stringify(data));
        if (!data.isSuccess) {
          this.$toast(data.msg || "获取数据失败");
          return;
        }

        var resultXmAllList = data.content.resultXmList || [];
        this.resultXmList = [];
        //个人报名 个人只能报单项赛  禁止报名团体赛
        // console.log(resultXmAllList);
        for (var i = 0; i < resultXmAllList.length; i++) {
          var dataList = resultXmAllList[i].DATALIST;
          var dataListTemp = [];
          for (var j = 0; j < dataList.length; j++) {
            var SSLXTYPE = dataList[j].SSLX.substr(1, 2);
            if (this.showXmlx === "DX") {
              if (SSLXTYPE !== "T") {
                dataListTemp.push(dataList[j]);
              }
            } else if (this.showXmlx === "TEAM") {
              if (SSLXTYPE === "T") {
                dataListTemp.push(dataList[j]);
              }
            }
          }
          if (dataListTemp.length > 0) {
            var tempItem = {
              XMJC: resultXmAllList[i].XMJC,
              ISBM: resultXmAllList[i].ISBM,
              DATALIST: dataListTemp
            };
            this.resultXmList.push(tempItem);
          }
        }
        if (this.reportLx === "DYBM") {
          if (this.resultXmList.length === 0) {
            this.$notify({
              type: "danger",
              message:
                "未检测到团体项目，请先联系领队，报名对应的团体项目后，队员才能进行报名",
              duration: 6000
            });
            return;
          }
        }
        this.maxRCount = data.content.maxRCount;
        this.ybmRCount = data.content.ybmRCount;
        this.SSMC = data.content.SSMC;
        this.ISBMRCOUNT = data.content.ISBMRCOUNT;
        this.MAXXMCOUNT = data.content.MAXXMCOUNT;
        this.STARTDATE = data.content.STARTDATE;
        this.ENDDATE = data.content.ENDDATE;

        // 队伍信息
        if (data.content.ryInfo) {
          this.DWQC = data.content.ryInfo.DWQC
            ? data.content.ryInfo.DWQC.VALUE
            : "";
          this.DWJC = data.content.ryInfo.DWJC
            ? data.content.ryInfo.DWJC.VALUE
            : "";
          this.LDXM = data.content.ryInfo.LDXM
            ? data.content.ryInfo.LDXM.VALUE
            : "";
          this.LDTEL = data.content.ryInfo.LDTEL
            ? data.content.ryInfo.LDTEL.VALUE
            : "";
        }

        // 计算已报名数量
        this.calculateRegisteredCount();

        // 更新筛选标签
        this.updateFilterTabs();
      });
    },
    calculateRegisteredCount() {
      // 计算已报名的项目数量
      let count = 0;
      this.resultXmList.forEach(xmGroup => {
        if (xmGroup.DATALIST && xmGroup.DATALIST.length > 0) {
          xmGroup.DATALIST.forEach(item => {
            if (item.ITEMISBM === "1") {
              count++;
            }
          });
        }
      });
      this.registeredCount = count;
    },
    updateFilterTabs() {
      // 获取所有唯一的组别
      const groups = this.resultXmList.map(xmGroup => xmGroup.XMJC);

      // 重新构建筛选标签
      this.filterTabs = [
        { label: "全部", value: "all" },
        ...groups.map(g => ({ label: g, value: g }))
      ];
    },
    getEndDate(bmset) {
      // 优先使用ENDCSDATE2，其次ENDCSDATE3，最后ENDCSDATE
      if (bmset.ENDCSDATE2 && bmset.ENDCSDATE2.length > 0) {
        return bmset.ENDCSDATE2;
      }
      if (bmset.ENDCSDATE3 && bmset.ENDCSDATE3.length > 0) {
        return bmset.ENDCSDATE3;
      }
      return bmset.ENDCSDATE || "";
    },
    getCountUnit(sslx) {
      // 根据SSLX判断项目类型返回单位
      if (!sslx) return "人";

      // BD、LD、GD 是3v3类型
      if (sslx === "BD" || sslx === "LD" || sslx === "GD") {
        return "对";
      }

      // 获取最后一个字符
      const lastChar = sslx.substr(-1);

      // S结尾是单打
      if (lastChar === "S") {
        return "人";
      }

      // D结尾是双打
      if (lastChar === "D") {
        return "对";
      }

      // T结尾是团体
      if (lastChar === "T") {
        return "队";
      }

      // 默认返回人
      return "人";
    },
    getProjectType(sslx) {
      // 根据SSLX判断项目类型
      if (!sslx) return "单打";
      const code = sslx.substr(1, 2);
      if (code === "D") return "双打";
      if (code === "T") return "团体";
      return "单打";
    },
    handleScroll() {
      this.isAtTop =
        window.pageYOffset <= 10 || document.documentElement.scrollTop <= 10;
    },
    onRefresh() {
      this.getXmData();
      setTimeout(() => {
        this.isLoading = false;
        this.$toast("刷新成功");
      }, 1000);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push("/");
    },
    switchTab(value) {
      this.currentTab = value;
    },
    handleProjectClick(item) {
      console.log("点击项目：", item);
    },
    handleModifyRegistration(item) {
      this.$dialog
        .confirm({
          title: "修改报名",
          message: `是否要取消报名 "${item.XMQC}"？`,
          confirmButtonText: "取消报名",
          cancelButtonText: "继续报名"
        })
        .then(() => {
          // 取消报名
          item.ITEMISBM = "0";
          this.calculateRegisteredCount();
          this.$toast("已取消报名");
        })
        .catch(() => {
          // 继续报名，不做任何操作
        });
    },
    navRmbmUrl(mxItem, ISBM) {
      // 检查报名人数限制
      const maxCount = this.maxRCount - 0;
      const currentCount = this.ybmRCount - 0;

      // 判断是否为有效数字
      if (!isNaN(maxCount) && !isNaN(currentCount)) {
        const remaining = maxCount - currentCount;
        if (remaining <= 0) {
          this.$toast("报名人数已满，无法继续报名");
          return;
        }
      }

      if (this.reportLx === "CJMDBM" && this.bmLx !== "GR") {
        this.$router.push({
          path: "/teamSelectCy",
          query: {
            ssid: this.ssid,
            xmid: mxItem.XMID,
            bmLx: "TEAM",
            dwid: this.dwid,
            czlx: this.czlx
          }
        });
        return;
      }

      var busData = {
        XMID: mxItem.XMID,
        checkBmrsLx: this.checkBmrsLx
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "checkBmrs" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 6000
          });
          return;
        }
        if (this.bmLx === "GR") {
          this.$router.push({
            path: "/addRyInfo",
            query: {
              ssid: this.ssid,
              xmid: mxItem.XMID,
              bmLx: "GR",
              dwid: "",
              czlx: this.czlx
            }
          });
        } else {
          //如果通过采集名单的方式报名  则跟老版本是一样的
          if (this.reportLx === "CJMDBM") {
            this.$router.push({
              path: "/teamSelectCy",
              query: {
                ssid: this.ssid,
                xmid: mxItem.XMID,
                bmLx: "TEAM",
                dwid: this.dwid,
                czlx: this.czlx
              }
            });
          } else if (this.reportLx === "LDBM") {
            //直接报名队伍，只能用于团体赛
            Dialog.confirm({
              title: "提示",
              message: "是否提交报名？"
            })
              .then(() => {
                var busData = {
                  DWID: this.dwid,
                  XMID: mxItem.XMID
                };
                var paramData = {
                  headerData: {
                    ssid: this.ssid,
                    op: "wapGL", //反射名称
                    methodName: "ldbmDw" //对应的方法名
                  },
                  busData: busData //参数内容
                };
                this.utilPost.paramData = paramData;
                this.utilPost.sendPost().then(data => {
                  this.$notify({
                    type: "success",
                    message: data.msg,
                    duration: 6000
                  });
                  if (data.isSuccess) {
                    var XMNM = data.content.XMNM;
                    var XMID = data.content.XMID;
                    var ISSF = data.content.ISSF;
                    if (ISSF === "1") {
                      Dialog.alert({
                        title: "报名成功",
                        message:
                          "请您在3个小时内完成缴费，超时未交费系统将会清除您的报名信息，请悉知"
                      }).then(() => {
                        this.$router.push({
                          path: "/alreadyBmxx",
                          query: {
                            ssid: this.ssid,
                            requestXmnm: XMNM,
                            requestXmid: XMID,
                            czlx: "ADD"
                          }
                        });
                      });
                    } else {
                      this.$router.push({
                        path: "/alreadyBmxx",
                        query: {
                          ssid: this.ssid,
                          requestXmnm: XMNM,
                          requestXmid: XMID,
                          czlx: "ADD"
                        }
                      });
                    }
                  }
                });
              })
              .catch(() => {
                // on cancel
              });
          } else if (this.reportLx === "DYBM") {
            //队员报名  直接按个人报名走，只不过需要指定对应的队伍ID
            if (this.dwid === "") {
              this.$notify({
                type: "danger",
                message: "队伍ID不能为空",
                duration: 6000
              });
              return;
            }
            if (mxItem.SSLX.substr(1, 2) === "T") {
              this.$router.push({
                path: "/addRyInfo",
                query: {
                  ssid: this.ssid,
                  xmid: mxItem.XMID,
                  bmLx: "TEAM",
                  dwid: this.dwid,
                  czlx: this.czlx,
                  ryid1Param: "",
                  ryid2Param: "",
                  checkBmrsLx: this.checkBmrsLx
                }
              });
            } else {
              this.$router.push({
                path: "/addRyInfo",
                query: {
                  ssid: this.ssid,
                  xmid: mxItem.XMID,
                  bmLx: "GR",
                  dwid: this.dwid,
                  czlx: this.czlx
                }
              });
            }
          } else {
            alert("类型不存在");
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.project-list-page {
  min-height: 100vh;
  background: #f5f6fa;
}

/deep/ .van-nav-bar {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;

  .van-nav-bar__title {
    color: #333;
    font-weight: 600;
    font-size: 1.125rem;
  }

  .van-nav-bar__text,
  .van-icon {
    color: #666;
  }
}

.content-wrapper {
  padding-top: 46px;
}

/* ==================== 比赛信息头部 ==================== */
.competition-header {
  position: relative;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  padding: 0.8rem 1rem 1rem;
  overflow: hidden;

  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
    opacity: 0.3;
  }

  .header-content {
    position: relative;
    z-index: 1;
  }
}

.competition-title {
  text-align: center;
  margin-bottom: 0.875rem;

  h2 {
    margin: 0 0 0.375rem 0;
    font-size: 1.125rem;
    font-weight: 700;
    color: #fff;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  p {
    margin: 0;
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.9);
  }
}

.stats-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 1rem;
  padding: 1rem;
}

.stat-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;

  .stat-num {
    font-size: 1.1rem;
    font-weight: 800;
    color: #fff;
    line-height: 1;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .stat-text {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}

.stat-divider {
  width: 1px;
  height: 2rem;
  background: rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

/* ==================== 队伍信息 ==================== */
.team-info-section {
  margin-top: 15px;
  padding: 0 1rem 0.75rem;
  background: #f5f6fa;
}

.team-info-card {
  background: #fff;
  border-radius: 0.875rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.team-info-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;

  .van-icon {
    font-size: 1rem;
    color: #185f9b;
  }
}

.team-info-content {
  padding: 0.75rem 1rem;
}

.info-row {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
  font-size: 0.8125rem;
  line-height: 1.5;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }
}

.info-label {
  flex-shrink: 0;
  width: 5rem;
  color: #666;
  font-weight: 500;
}

.info-value {
  flex: 1;
  color: #333;
  font-weight: 600;
  word-break: break-all;
}

/* ==================== 筛选栏 ==================== */
.filter-section {
  background: #fff;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-tabs {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.filter-tab {
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  background: #f5f6fa;
  border-radius: 1.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &.active {
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
  }

  &:active {
    transform: scale(0.95);
  }
}

/* ==================== 项目选择提示 ==================== */
.project-tip-section {
  padding: 0.75rem 1rem;
  background: #f5f6fa;
}

.tip-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #e8f4ff 0%, #d4e9ff 100%);
  border-left: 3px solid #185f9b;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  color: #333;
  line-height: 1.5;

  .van-icon {
    font-size: 1rem;
    color: #185f9b;
    flex-shrink: 0;
  }

  span {
    flex: 1;
    font-weight: 500;
  }
}

/* ==================== 项目列表 ==================== */
.project-list {
  padding: 1rem;
}

/* 组别分组 */
.group-section {
  margin-bottom: 2rem;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  /* 组别背景装饰 */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: linear-gradient(
      135deg,
      rgba(24, 95, 155, 0.02) 0%,
      rgba(26, 107, 168, 0.02) 100%
    );
    border-radius: 1rem;
    z-index: 0;
  }
}

/* 项目卡片包装器 - 添加动画 */
.project-item-wrapper {
  margin-bottom: 0.75rem;
  animation: fadeInUp 0.4s ease;

  &:last-child {
    margin-bottom: 0;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.group-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  margin-bottom: 0.875rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-radius: 0.875rem;
  box-shadow: 0 4px 16px rgba(24, 95, 155, 0.25);
  position: relative;
  overflow: hidden;

  /* 装饰性背景 */
  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -20%;
    width: 150px;
    height: 150px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.15) 0%,
      transparent 70%
    );
    border-radius: 50%;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -30%;
    left: -10%;
    width: 100px;
    height: 100px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    border-radius: 50%;
  }
}

.group-title {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .group-icon {
    font-size: 1.25rem;
    line-height: 1;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }

  .group-name {
    font-size: 0.9375rem;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
}

.group-count {
  position: relative;
  z-index: 1;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.625rem;
  border-radius: 0.875rem;
}

.project-item {
  position: relative;
  z-index: 1;
  background: #fff;
  border-radius: 1rem;
  padding: 0.875rem;
  margin-bottom: 0.875rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid transparent;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;

  /* 左侧装饰条 */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #185f9b 0%, #1a6ba8 100%);
    transition: width 0.3s ease;
  }

  /* 悬停效果 */
  &:hover {
    transform: translateX(4px);
    box-shadow: 0 6px 24px rgba(24, 95, 155, 0.2);
    border-color: rgba(24, 95, 155, 0.2);

    &::before {
      width: 6px;
    }
  }

  &:active {
    transform: translateX(2px) scale(0.99);
    box-shadow: 0 4px 16px rgba(24, 95, 155, 0.15);
  }

  &:last-child {
    margin-bottom: 0;
  }

  /* 已报名样式 */
  &.is-registered {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border-color: rgba(52, 211, 153, 0.3);

    &::before {
      background: linear-gradient(180deg, #34d399 0%, #10b981 100%);
    }

    &:hover {
      box-shadow: 0 6px 24px rgba(52, 211, 153, 0.2);
      border-color: rgba(52, 211, 153, 0.4);
    }
  }
}

.project-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.625rem;
}

.project-left {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  flex: 1;
  min-width: 0;
}

.project-right {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  margin-left: 0.5rem;
}

/* 费用标签容器 */
.fee-tags {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.375rem;
}

/* 已报名标签样式 */
.registered-badge {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.625rem;
  background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 1rem;
  box-shadow: 0 2px 6px rgba(52, 211, 153, 0.3);

  .van-icon {
    font-size: 0.875rem;
  }
}

.project-badge {
  flex-shrink: 0;
  padding: 0.5rem 0.75rem;
  border-radius: 0.625rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  overflow: hidden;

  /* 光泽效果 */
  &::after {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      transparent 30%,
      rgba(255, 255, 255, 0.3) 50%,
      transparent 70%
    );
    transform: translateX(-100%);
  }

  /* 单打类型 - 蓝色 */
  &.男单,
  &.女单,
  &.单打 {
    background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  }

  /* 双打类型 - 跑兔蓝 */
  &.男双,
  &.女双,
  &.混双,
  &.双打 {
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  }

  /* 3v3/团队类型 - 绿色 */
  &.混3V3,
  &.3v3,
  &.3v3 {
    background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  }

  /* 团体类型 - 粉色 */
  &.混团,
  &.团体 {
    background: linear-gradient(135deg, #eb2f96 0%, #ff85c0 100%);
  }
}

.project-info {
  flex: 1;
  min-width: 0;
}

/* 标题行 */
.title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.375rem;
}

.project-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #2c3e50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 0.3px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  flex: 1;
  min-width: 0;
}

/* 跨组标签 - 在标题行 */
.cross-group-tag {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
  border: 1px solid #66bb6a;
  color: #2e7d32;
  font-weight: 600;
  font-size: 0.6875rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 4px rgba(102, 187, 106, 0.2);

  .van-icon {
    font-size: 0.75rem;
    color: #2e7d32;
  }
}

.project-meta {
  display: flex;
  align-items: center;
  gap: 1.125rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.9375rem;
  color: #666;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  background: #f8f9fa;
  border-radius: 0.5rem;

  .van-icon {
    font-size: 1.0625rem;
    color: #185f9b;
  }

  /* 已报名人数 - 蓝色 */
  .registered-count {
    color: #185f9b;
    font-weight: 700;
  }

  /* 分隔符 */
  .divider {
    color: #999;
    margin: 0 0.125rem;
  }

  /* 最大人数 - 灰色 */
  .max-count {
    color: #999;
    font-weight: 500;
  }
}

/* 金额标签特殊样式 */
.fee-item {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
  border: 1.5px solid #ffb74d;
  color: #e65100;
  font-weight: 700;
  font-size: 0.875rem;
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.25);
  position: relative;
  overflow: visible;

  &::before {
    content: "";
    position: absolute;
    inset: -2px;
    border-radius: 0.5rem;
    background: linear-gradient(135deg, #ff9800, #f57c00);
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: -1;
  }

  &:hover::before {
    opacity: 0.1;
  }

  .van-icon {
    color: #ff9800;
    font-size: 1.0625rem;
    filter: drop-shadow(0 1px 2px rgba(255, 152, 0, 0.3));
  }
}

/* 会员优惠标签样式 */
.member-tag {
  font-size: 0.6875rem;
  padding: 0.25rem 0.5rem;
  font-weight: 600;

  /deep/ .van-tag--warning {
    background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
    color: #fa8c16;
    border: 1px solid #ffd591;
  }
}

.project-footer {
  padding-top: 0.625rem;
  border-top: 1px solid #c2c2c2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.625rem;

  /deep/ .van-button {
    min-width: 4rem;
    height: 1.75rem;
    font-size: 0.75rem;
    font-weight: 700;
    background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
    transition: all 0.3s ease;
    flex-shrink: 0;

    &:active {
      transform: scale(0.95);
      box-shadow: 0 2px 6px rgba(24, 95, 155, 0.3);
    }
  }

  /deep/ .modify-btn {
    background: linear-gradient(135deg, #34d399 0%, #10b981 100%);
    color: #fff;
    border: none;
    box-shadow: 0 4px 12px rgba(52, 211, 153, 0.3);

    &:active {
      transform: scale(0.95);
      box-shadow: 0 2px 6px rgba(52, 211, 153, 0.3);
    }
  }
}

.birth-date {
  display: flex;
  align-items: center;
  margin-right: auto;
  gap: 0.5rem;
  font-size: 0.8125rem;
  color: #666;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 0.625rem;
  border: 1px solid #e9ecef;
  flex: 1;
  min-width: 0;

  .van-icon {
    font-size: 1rem;
    color: #185f9b;
    flex-shrink: 0;
  }
}

/* 空状态 */
.empty-state {
  padding: 4rem 1.25rem;
  text-align: center;
}

/* 响应式 */
@media (max-width: 480px) {
  .competition-title h2 {
    font-size: 1rem;
  }

  .stats-summary {
    gap: 1rem;
    padding: 0.875rem;
  }

  .stat-box .stat-num {
    font-size: 1.1rem;
  }

  .project-title {
    font-size: 0.9375rem;
  }

  .project-meta {
    gap: 0.75rem;
  }

  .meta-item {
    font-size: 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectListIndex/ProjectListIndex.vue